import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";

import PageHeader from "components/PageHeader";
import DataTable from "components/DataTable";
import BranchFilterSelect from "components/BranchFilterSelect";

import useAuditLogData from "layouts/tables/data/auditLogTableData";

function AuditLogs() {
  const {
    columns,
    rows,
    isLoading,
    error,
    branches,
    canFilterByBranch,
    branchFilter,
    setBranchFilter,
    actionFilter,
    setActionFilter,
    typeFilter,
    setTypeFilter,
    types,
    serverPagination,
  } = useAuditLogData();

  if (error) {
    return (
      <Typography color="error" sx={{ py: 6 }}>
        Error: {error}
      </Typography>
    );
  }

  return (
    <Box>
      <PageHeader
        title="Audit Log"
        subtitle="Every create, update, and delete across the system — who did what, and when."
      />

      <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="flex-end" mb={2}>
        {canFilterByBranch && (
          <BranchFilterSelect branches={branches} value={branchFilter} onChange={setBranchFilter} />
        )}
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel id="action-filter-label">Action</InputLabel>
          <Select
            labelId="action-filter-label"
            label="Action"
            value={actionFilter || ""}
            onChange={(e) => setActionFilter(e.target.value || null)}
          >
            <MenuItem value="">All Actions</MenuItem>
            <MenuItem value="created">Created</MenuItem>
            <MenuItem value="updated">Updated</MenuItem>
            <MenuItem value="deleted">Deleted</MenuItem>
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel id="type-filter-label">Type</InputLabel>
          <Select
            labelId="type-filter-label"
            label="Type"
            value={typeFilter || ""}
            onChange={(e) => setTypeFilter(e.target.value || null)}
          >
            <MenuItem value="">All Types</MenuItem>
            {types.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <Card>
        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          showTotalEntries
          serverPagination={serverPagination}
          loading={isLoading}
        />
      </Card>
    </Box>
  );
}

export default AuditLogs;
